// publicAuthUtils.js

const STORAGE_KEY = 'pageAccessInfo';

export const saveAccessInfo = (email, pageId) => {
  const timestamp = new Date().getTime();
  const accessInfo = {
    email,
    pageId,
    timestamp
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(accessInfo));
};

export const isSessionActive = (pageId) => {
  const accessInfo = JSON.parse(localStorage.getItem(STORAGE_KEY));
  console.log(accessInfo, pageId)
  if (!accessInfo || accessInfo.pageId !== pageId || !accessInfo.email) {
    return false; // No valid session
  }

  const currentTime = new Date().getTime();
  const oneHourInMilliseconds = 60 * 60 * 1000;

  if (currentTime - accessInfo.timestamp > oneHourInMilliseconds) {
    localStorage.removeItem(STORAGE_KEY); // Clear expired session
    return false;
  }

  return true; // Session is still active
};

export const clearAccessInfo = () => {
  localStorage.removeItem(STORAGE_KEY);
};
